import { css } from "../helpers/webComponents";

const BASE_URL: string = "http://localhost:3001";

const styles: string = css`
    :host {
        background-color: #1D2434;
        border-top: 3px solid #3B4B62;
        color: white;
        display: flex;
        flex-direction: column;
        padding: 10px;
        position: absolute;
        z-index: 1;
        top: 1rem;
        right: 1rem;
        width: 33%;
        height: 50%;
    }

    .inventory-header {
        font-size: 1.2em;
        margin-bottom: 10px;
    }

    .inventory-list {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: center;
    }

    .inventory-item {
        font-size: .9rem;
        padding: 5px 10px;
        border-radius: 5px;
        cursor: pointer;
    }
`;

/**
 * Represents the inventory component.
 * This component displays the player's inventory and allows them to interact with it.
 */
export class InventoryComponent extends HTMLElement {
    private items: { id?: number; name: string; alias?: string; description?: string }[] = [];
    private isOpen: boolean = false;
    private isLoading: boolean = false;
    private hasError: boolean = false;
    private errorMessage: string = "";

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.render();
    }

    public connectedCallback(): void {
        this.style.display = "none";
        void this.fetchInventory();
    }

    public disconnectedCallback(): void {
        this.style.display = "none";
    }

    public toggle(): void {
        this.isOpen = !this.isOpen;
        this.style.display = this.isOpen ? "flex" : "none";

        // Refresh the inventory when opened
        if (this.isOpen) {
            void this.fetchInventory();
        }
    }

    /**
     * Fetch the player's inventory from the API.
     *
     * @returns Promise that resolves when the inventory has been fetched.
     */
    private async fetchInventory(): Promise<void> {
        this.isLoading = true;
        this.hasError = false;
        this.render();

        // Fetch the inventory from the API
        try {
            const response: Response = await fetch(BASE_URL + "/inventory");

            // Check if the response is successful
            if (!response.ok) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            // Check if the data exists
            if (!data) {
                console.warn("No data received from server");
                this.items = [];
            }
            else if (!data.items) {
                console.warn("No items property in data:", data);
                this.items = [];
            }
            else {
                this.items = data.items;
                console.log("Inventory fetched successfully:", this.items);
            }
        }
        // Handle any errors that happen during the fetching
        catch (error) {
            console.error("Error fetching inventory:", error);

            // Set the error state and clear the items
            this.hasError = true;
            this.errorMessage = error instanceof Error ? error.message : "Unknown error occurred";
            this.items = [];
        }
        // Ensure the loading state is cleared
        finally {
            this.isLoading = false;
            // Render the component with the new state when the fetch is successful
            this.render();
        }
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
            <div class="inventory-header">Inventory</div>
                    <div class="inventory-list">
                        ${this.items.length > 0
                            ? this.items.map(item => `<div class="inventory-item" data-id="${item.id || ""}">${item.name}</div>`).join("")
                            : "<p>Geen items</p>"}
                    </div>
            
        `;
    }
}
